'use client';
import React, { useEffect, useRef } from 'react';

type AnimationsWrapperProps = {
  children: React.ReactNode;
};

export default function AnimationsWrapper({ children }: AnimationsWrapperProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function markIsVisible(section: Element) {
      section.classList.add('is-visible');
      observer.unobserve(section); // Stop observing once it's visible
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            markIsVisible(entry.target);
          }
        });
      },
      {
        threshold: 0.01, // Trigger when just 1% is visible
      },
    );

    const container = containerRef.current;
    if (container) {
      const sections = container.querySelectorAll('section');
      sections.forEach((section) => observer.observe(section));

      // Trigger the observer callback for elements already in view
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
        if (isInViewport) {
          markIsVisible(section);
        } else {
          section.classList.add('is-animated');
        }
      });
    }

    return () => {
      if (container) {
        const sections = container.querySelectorAll('section');
        sections.forEach((section) => observer.unobserve(section));
      }
    };
  }, []);

  return (
    <div className="modules-container h-auto grow [&>*:first-child>*]:pt-20" ref={containerRef}>
      {children}
    </div>
  );
}
